import styled from 'styled-components'
import { colors } from 'Styled/variables'

export const TrackDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const TrackDetailsTitle = styled.span`
  font-size: 10px;
  color: ${colors.mainText};
`

export const TrackDetailsRow = styled.span`
  display: grid;
  grid-template-columns: 60px 1fr;
  gap: 8px;
`

export const TrackDetailsRowLabel = styled.span`
  display: inline-block;
  width: 60px;
  font-size: 14px;
  line-height: 21px;
  color: ${colors.greyTextWhiteBg};
`

export const TrackDetailsRowInfo = styled.span<{ orange?: boolean }>`
  font-size: 14px;
  line-height: 21px;
  color: ${({ orange }) => (orange ? colors.messegesYellow1 : colors.mainText)};
`
